import * as React from 'react';
import {
  InfoRowContainer,
  InfoRowDescription,
  InfoRowTime,
  InfoRowTitle,
  SpeakerDetailsContainer,
  TitleTagContainer,
} from './InfoRow.style';
import ScheduleSpeaker from '../schedule-speaker/ScheduleSpeaker';
import Tag from '../tag/Tag';
import { RichText } from 'prismic-reactjs';

const InfoRow = ({ rowData, isInPerson }) => {
  const {
    primary: {
      schedule_item_description: scheduleItemDescription,
      schedule_item_name: scheduleItemName,
      time,
      tag,
      sameTime,
      speaker_details: {
        document: {
          data: { speaker_details: speakerDetails },
        },
      },
    },
    id,
  } = rowData;
  return (
    <InfoRowContainer sameTime={sameTime}>
      <InfoRowTime isInPerson={isInPerson}>{time.text}</InfoRowTime>
      <TitleTagContainer>
        <InfoRowTitle isInPerson={isInPerson}>
          {scheduleItemName.text}
        </InfoRowTitle>
        {tag.text !== '' && <Tag title={tag} />}
      </TitleTagContainer>
      <SpeakerDetailsContainer>
        {speakerDetails.map(s => (
          <ScheduleSpeaker
            key={id}
            isInPerson={isInPerson}
            speakerDetails={s}
          />
        ))}
      </SpeakerDetailsContainer>
      <InfoRowDescription isInPerson={isInPerson}>
        {RichText.render(scheduleItemDescription.richText)}
      </InfoRowDescription>
    </InfoRowContainer>
  );
};
export default InfoRow;
